import { getUserData } from 'app/store/actions/user/user.actions';
import axios from 'axios';

export const GET_USERS = '[CONTACTS APP] GET USERS';
export const SET_SEARCH_DEVICE_TEXT = '[CONTACTS APP] SET SEARCH DEVICE TEXT';
export const OPEN_NEW_CONTACT_DIALOG = '[CONTACTS APP] OPEN NEW CONTACT DIALOG';
export const CLOSE_NEW_CONTACT_DIALOG = '[CONTACTS APP] CLOSE NEW CONTACT DIALOG';
export const OPEN_EDIT_CONTACT_DIALOG = '[CONTACTS APP] OPEN EDIT CONTACT DIALOG';
export const CLOSE_EDIT_CONTACT_DIALOG = '[CONTACTS APP] CLOSE EDIT CONTACT DIALOG';
export const ADD_CONTACT = '[CONTACTS APP] ADD CONTACT';
export const UPDATE_CONTACT = '[CONTACTS APP] UPDATE CONTACT';
export const REMOVE_CONTACT = '[CONTACTS APP] REMOVE CONTACT';
export const REMOVE_CONTACTS = '[CONTACTS APP] REMOVE CONTACTS';
export const TOGGLE_STARRED_CONTACT = '[CONTACTS APP] TOGGLE STARRED CONTACT';
export const TOGGLE_STARRED_CONTACTS = '[CONTACTS APP] TOGGLE STARRED CONTACTS';
export const SET_CONTACTS_STARRED = '[CONTACTS APP] SET CONTACTS STARRED ';

export function getUsers(routeParams) {
	// const request = axios.get('/api/contacts-app/contacts', {
	// 	params: routeParams
	// });
	let data = [
		{no: '1', deviceName: 'SCAI-1422219040512', projectID: 'None', globalIP: '131.147.178.243/32', localIP: '192.168.11.6/32', 
			deviceUUID: '3767d512-5d77-530f-9a47-141c98629996', status: 'ONLINE'},
		{no: '2', deviceName: 'FAKE-SCAI', projectID: 'None', globalIP: '77.143.177.246/32', localIP: '192.168.11.6/32', 
			deviceUUID: '3767d512-5d77-530f-9a47-141c98629996', status: 'ONLINE'},
	];
	return {
		type: GET_USERS,
		payload: data,
	};
}

export function setSearchText(event) {
	return {
		type: SET_SEARCH_DEVICE_TEXT,
		searchText: event.target.value
	};
}

export function openNewContactDialog() {
	return {
		type: OPEN_NEW_CONTACT_DIALOG
	};
}

export function closeNewContactDialog() {
	return {
		type: CLOSE_NEW_CONTACT_DIALOG
	};
}

export function openEditContactDialog(data) {
	return {
		type: OPEN_EDIT_CONTACT_DIALOG,
		data
	};
}

export function closeEditContactDialog() {
	return {
		type: CLOSE_EDIT_CONTACT_DIALOG
	};
}

export function addContact(newContact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/add-contact', {
			newContact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: ADD_CONTACT
				})
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function updateContact(contact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/update-contact', {
			contact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: UPDATE_CONTACT
				})
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function removeContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACT
				})
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function removeContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACTS
				})
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function toggleStarredContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/toggle-starred-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: TOGGLE_STARRED_CONTACT
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function toggleStarredContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/toggle-starred-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: TOGGLE_STARRED_CONTACTS
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function setContactsStarred(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/set-contacts-starred', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: SET_CONTACTS_STARRED
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}

export function setContactsUnstarred(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().DeviceApp.contacts;

		const request = axios.post('/api/contacts-app/set-contacts-unstarred', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: SET_CONTACTS_STARRED
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getUsers(routeParams)))
		);
	};
}
